import clsx from 'clsx';
import { type ReactNode } from 'react';
import { Dialog, Popover, type PopoverProps } from 'react-aria-components';

import styles from './PopoverTooltip.module.css';
import commonStyles from './Tooltip.module.css';
import { TooltipArrow } from './TooltipArrow';

export type Props = Pick<
  PopoverProps,
  'placement' | 'offset' | 'isOpen' | 'onOpenChange' | 'triggerRef' | 'aria-label'
> & {
  text: ReactNode;
  theme?: 'light' | 'dark';
  /** Extra class on the popover shell, so a caller can override its chrome
      (background, shadow, width, arrow colour) without changing the shared base. */
  className?: string;
};

// This component should only be used inside MenuItem
// https://github.com/adobe/react-spectrum/discussions/8437
export function PopoverTooltip({
  text,
  offset = 14,
  isOpen,
  onOpenChange,
  placement,
  triggerRef,
  'aria-label': ariaLabel,
  theme = 'dark',
  className,
}: Props) {
  return (
    <Popover
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      triggerRef={triggerRef}
      offset={offset}
      placement={placement}
      className={clsx(commonStyles.tooltip, commonStyles[theme], className)}
    >
      {/* Pass the theme through: without it the arrow always rendered dark,
          leaving light popovers with a mismatched dark/"broken" pointer. */}
      <TooltipArrow theme={theme} />
      <Dialog className={styles.dialog} aria-label={ariaLabel}>
        {text}
      </Dialog>
    </Popover>
  );
}
